module.exports = __webpack_public_path__ + "static/cureapp-logo-ac3e2d1568a0983a230b2986a4134696.png";